import { __read } from '../../../external/tslib/tslib.es6.mjs.js';
import { useState, useEffect } from 'react';

var getScrollbarWidth = function () {
    /* istanbul ignore next */
    if (typeof document === 'undefined' || !document) {
        return 0;
    }
    var el = document.createElement('div');
    var style = el.style;
    style.position = 'absolute';
    style.width = '100px';
    style.height = '100px';
    style.left = '-999px';
    style.top = '-999px';
    style.overflow = 'scroll';
    document.body.insertBefore(el, null);
    var clientWidth = el.clientWidth;
    // el.remove doesn't work in IE
    document.body.removeChild(el);
    return clientWidth === 0 ? undefined : 100 - clientWidth;
};
var useScrollbarWidth = function () {
    var _a = __read(useState(0), 2), scrollbarWidth = _a[0], setScrollbarWidth = _a[1];
    useEffect(function () {
        setScrollbarWidth(getScrollbarWidth());
    }, []);
    useEffect(function () {
        var handleResize = function () {
            setScrollbarWidth(getScrollbarWidth());
        };
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return scrollbarWidth;
};

export { useScrollbarWidth };
